/**
 * Sportybella product-card color swatches.
 * On click: swaps the parent card's main image to the variant's image.
 * Applied 2026-04-24.
 */
(function () {
  'use strict';

  function swapCardImage(btn) {
    var imageUrl = btn.getAttribute('data-variant-image');
    if (!imageUrl) return;

    // Walk up to the nearest card wrapper (Dawn variants: .card-wrapper, .card, li.grid__item)
    var card = btn.closest('.card-wrapper, .card, li.grid__item, .product-card-wrapper');
    if (!card) return;

    // Find the main image — Dawn card structure has .card__media img
    var mainImg =
      card.querySelector('.card__media img.motion-reduce') ||
      card.querySelector('.card__media img') ||
      card.querySelector('.media img') ||
      card.querySelector('.card__inner img');
    if (!mainImg) return;

    // Swap src + clear srcset (so browser uses the new src, not a cached srcset)
    mainImg.src = imageUrl;
    if (mainImg.hasAttribute('srcset')) {
      mainImg.removeAttribute('srcset');
    }
    // If the image is inside a <picture>, clear <source srcset> too
    var picture = mainImg.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (s) {
        s.removeAttribute('srcset');
      });
    }
  }

  function markSelected(btn) {
    var container = btn.closest('.sb-card-swatches');
    if (!container) return;
    container.querySelectorAll('.sb-card-swatch').forEach(function (s) {
      s.classList.toggle('is-selected', s === btn);
    });
  }

  function handleClick(e) {
    var btn = e.currentTarget;
    swapCardImage(btn);
    markSelected(btn);
  }

  function bind(btn) {
    if (btn.dataset.swatchBound === '1') return;
    btn.dataset.swatchBound = '1';
    btn.addEventListener('click', handleClick);
  }

  function init() {
    document.querySelectorAll('.sb-card-swatch').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Catch swatches injected after initial load (AJAX pagination, filters, infinite scroll)
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains('sb-card-swatch')) bind(n);
          if (n.querySelectorAll) n.querySelectorAll('.sb-card-swatch').forEach(bind);
        });
      });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
